/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const BREADCRUMB_LABELS = {
  dashboard: "Dashboard",
  receitaxdespesa: "Receita x despesa",
  operation: "Operações",
  extract: "Extrato",
  dividendos: "Dividendos e proventos",
  posicao: "Posição",
  rebalancear: "Rebalancear carteira",
  pontuar: "Peso por ativo",
  calculadora: "Simulador de alocação",
  checkout: "Checkout",
  pagamento: "Pagamento",
  mercado: "Mercado",
  entrar: "Entrar",
  "criar-conta": "Criar conta",
  sair: "Sair",
  "esqueci-senha": "Esqueci minha senha",
  "redefinir-senha": "Redefinir senha",
};

function Breadcrumbs({ icon, title, route, light, rootRoute, basePath }) {
  const routes = route.slice(0, -1);
  const formatBreadcrumbLabel = (value = "") =>
    BREADCRUMB_LABELS[value] || value.replace(/-/g, " ");

  const buildBreadcrumbPath = (index) => {
    const pathSegments = routes.slice(0, index + 1);
    return `${basePath}/${pathSegments.join("/")}`.replace(/\/+/g, "/");
  };

  return (
    <MDBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Link to={rootRoute}>
          <MDTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </MDTypography>
        </Link>
        {routes.map((el, index) => (
          <Link to={buildBreadcrumbPath(index)} key={el}>
            <MDTypography
              component="span"
              variant="button"
              fontWeight="regular"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {formatBreadcrumbLabel(el)}
            </MDTypography>
          </Link>
        ))}
        <MDTypography
          variant="button"
          fontWeight="regular"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {formatBreadcrumbLabel(title)}
        </MDTypography>
      </MuiBreadcrumbs>
      <MDTypography
        fontWeight="bold"
        variant="h6"
        color={light ? "white" : "dark"}
        noWrap
      >
        {formatBreadcrumbLabel(title)}
      </MDTypography>
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
  rootRoute: "/",
  basePath: "",
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
  rootRoute: PropTypes.string,
  basePath: PropTypes.string,
};

export default Breadcrumbs;
